module.exports = __webpack_public_path__ + "static/img/CD.eb45d362.svg";